import { render, staticRenderFns } from "./RecommendTeacher.vue?vue&type=template&id=6321ee52&scoped=true&"
import script from "./RecommendTeacher.vue?vue&type=script&lang=js&"
export * from "./RecommendTeacher.vue?vue&type=script&lang=js&"
import style0 from "./RecommendTeacher.vue?vue&type=style&index=0&id=6321ee52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6321ee52",
  null
  
)

export default component.exports